import request from 'utils/request'

export const getMCAXS521InitRequest = () =>
  request({
    url: '/MCAXS521/init',
    method: 'post',
  })
